import React from 'react';
import { Box, Typography } from '@mui/material';
import LabelValueItem from '../../lead/components/LabelValueItem';
import useDateFormat from '../../../hooks/useDateFormat';
import formatMoney from '../../../utils/formatMoney';
import { User } from '@tassomutuo-backoffice/types';
import { Link } from 'react-router-dom';
import { CtaButton } from '@tassomutuo-backoffice/ui';

interface IProps {
  lead: Record<string, string> | Record<string, { value: string }>;
  members?: Pick<User, 'id' | 'name' | 'email' | 'hubspotOwnerId'>[];
  isPrinting?: boolean;
}

const LeadCardList = ({ lead, members, isPrinting = false }: IProps) => {
  // const { renderActionRequired } = useLeadActionRequired();
  const { formatDate } = useDateFormat();

  const owner = members?.find(
    (m) => m.hubspotOwnerId === lead.hubspot_owner_id
  );

  const leadProperties = lead;
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'white',
        m: 4,
        p: 2,
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexWrap: 'wrap-reverse',
            flexDirection: 'row',
            gap: 2,
            borderBottom: (th) => `1px solid ${th.palette.divider}`,
            width: '100%',
            pb: 1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap-reverse',
              gap: 2,
              pb: 1,
            }}
          >
            <Typography
              fontWeight="bold"
              textTransform="uppercase"
              sx={{ color: 'rgba(239, 68, 68, 1)' }}
            >
              {owner?.name}
            </Typography>
            <Typography
              fontWeight="bold"
              sx={{ color: 'rgba(239, 68, 68, 1)' }}
            >
              {owner?.email}
            </Typography>
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap-reverse',
              gap: 2,
              pb: 1,
            }}
          >
            <Typography
              fontWeight="bold"
              sx={{ color: 'rgba(239, 68, 68, 1)' }}
            >
              {typeof leadProperties?.why_dropped === 'string'
                ? leadProperties?.why_dropped?.split('.').pop()
                : 'N/A'}
            </Typography>
          </Box>
        </Box>

        <Box pt={1}>
          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap"
            gap={2}
          >
            <Box>
              <Typography
                sx={{ color: (th) => th.palette.secondary.dark }}
                variant="h5"
                fontWeight="bold"
              >
                {typeof leadProperties.dealname === 'string'
                  ? leadProperties.dealname
                  : 'N/A'}
              </Typography>
              <Typography variant="h6">
                {typeof leadProperties.phone_number === 'string'
                  ? leadProperties.phone_number
                  : 'N/A'}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
              <Typography
                variant="h6"
                textAlign={'right'}
                color={'rgba(239, 68, 68, 1)'}
              >
                PERSO
              </Typography>
              <Typography variant="h4" color={'rgba(239, 68, 68, 1)'}>
                {formatMoney(Number(leadProperties?.amount) || 0)}
              </Typography>
            </Box>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            flexWrap="wrap-reverse"
            gap={2}
            mt={2}
          >
            <Box display="flex" gap={4}>
              <LabelValueItem
                label="Valore immobile"
                value={
                  leadProperties.property_value
                    ? formatMoney(+leadProperties.property_value)
                    : 'N/A'
                }
              />

              <LabelValueItem
                label="Importo mutuo"
                value={
                  leadProperties.loan_amount
                    ? formatMoney(+leadProperties.loan_amount)
                    : 'N/A'
                }
              />
            </Box>
            <LabelValueItem
              containerSx={{ alignItems: { sm: 'flex-end' } }}
              label="Data creazione"
              value={
                leadProperties.createdate
                  ? '' +
                    formatDate(
                      typeof leadProperties.createdate === 'object'
                        ? leadProperties.createdate.value
                        : leadProperties.createdate,
                      'dd/MM/yyyy HH:mm'
                    )
                  : 'N/A'
              }
            />
            <LabelValueItem
              containerSx={{ alignItems: { sm: 'flex-end' } }}
              label="Data ultima attività"
              value={
                leadProperties.notes_last_updated
                  ? '' +
                    formatDate(
                      typeof leadProperties.notes_last_updated === 'object'
                        ? leadProperties.notes_last_updated.value
                        : leadProperties.notes_last_updated,
                      'dd/MM/yyyy HH:mm'
                    )
                  : 'N/A'
              }
            />
            <LabelValueItem
              containerSx={{ alignItems: { sm: 'flex-end' } }}
              label="Data operazione immobiliare"
              value={
                leadProperties.data_operazione_immobiliare
                  ? '' +
                    formatDate(
                      typeof leadProperties.data_operazione_immobiliare ===
                        'object'
                        ? leadProperties.data_operazione_immobiliare.value
                        : leadProperties.data_operazione_immobiliare,
                      'dd/MM/yyyy'
                    )
                  : 'N/A'
              }
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          flexWrap: 'wrap',
          gap: 2,
          bgcolor: 'white',
          mt: 2,
        }}
      ></Box>
      {!isPrinting && (
        <Box
          sx={{
            width: { sm: '100%', xs: '100%' },
            maxWidth: '400px',
            alignSelf: 'flex-end',
            mt: 2,
          }}
        >
          <Link
            to={`/lead/${leadProperties.hs_object_id}`}
            style={{
              textDecoration: 'none',
            }}
          >
            <CtaButton
              sx={{
                // bgcolor: th.palette.primary.light,
                width: { sm: '100%', xs: '100%' },
                maxWidth: '400px',
              }}
              variant="contained"
            >
              <Typography fontWeight="bold" p={1}>
                Visualizza i dettagli della lead
              </Typography>
            </CtaButton>
          </Link>
        </Box>
      )}
    </Box>
  );
};

export default LeadCardList;
